export default __webpack_public_path__ + "static/media/market-active.4fd07023.svg";